<!--耗金额统计-->
<template>
  <div class="app-container">
    <!--    查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="queryParam.searchDay"
              type="monthrange"
              range-separator=""
              start-placeholder="开始"
              value-format="yyyy-MM"
              end-placeholder="结束"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button
          type="warning"
          size="medium"
          class="operator-btn2"
          icon="el-icon-refresh"
          @click="handleResetSearch()"
          >重 置</el-button
        >
        <el-button
          type="primary"
          size="medium"
          class="operator-btn"
          icon="el-icon-search"
          @click="onBtnSearch()"
          >查 询</el-button
        >
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px">数据列表</span>
      </div>
      <div></div>
    </div>
    <div class="table-container" style="margin-top: 0px">
      <el-table
        ref="tableData"
        :data="tableData"
        v-loading="listLoading"
        border
        highlight-current-row
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          prop="month"
          label="月份"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="buyCardNum"
          label="购卡总数"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="newChildNum"
          label="新建用户数"
        ></el-table-column>
        <el-table-column prop="rangeDes" label="成功率"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style scoped>
/deep/ .el-table th.el-table__cell > .cell {
  width: 90%;
  height: auto;
  background: #ecf3fd;
  border-radius: 8px;
}
/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>
<script>
import globaldata from "../../../utils/globaldata";
import { addReason, delReason, selectall } from "../../../api/cancelBookReason";
import commonUtils from "../../../utils/commonUtils";
import messageUtils from "../../../utils/messageUtils";
import { selectConsumeMoneyData } from "../../../api/bas/basConsumeData";
import timeUtils from "../../../utils/timeUtils";
import { formatDate } from "../../../utils/date";
import enumsUtil, {
  EChildGender,
  EUserExpStatu,
} from "../../../utils/enumsUtil";
import {
  getBuyVipRate,
  queryPageStatisticsDetail,
} from "../../../api/mkt/MktStatistics";

export default {
  data() {
    return {
      tableData: [],
      listLoading: true,
      queryParam: {},
    };
  },
  created() {
    this.initDate();
    this.fitchData();
  },
  methods: {
    initDate() {
      let nowDate = new Date();
      let yD = timeUtils.getFirstDayOfHYear(nowDate);
      this.queryParam.searchDay = [
        formatDate(yD[0], "yyyy-MM"),
        formatDate(nowDate, "yyyy-MM"),
      ];
    },

    //点击查询按钮
    onBtnSearch() {
      this.fitchData();
    },
    fitchData() {
      this.listLoading = true;
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
        startMonth: this.queryParam.searchDay[0],
        endMonth: this.queryParam.searchDay[1],
      };
      const loading = this.myLoading();
      getBuyVipRate(param).then((response) => {
        this.listLoading = false;
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }

        this.refreshData(data);
      });
    },
    //刷新页面数据
    refreshData(list) {
      this.tableData = list;
      for (let i = 0; i < this.tableData.length; ++i) {
        let data = this.tableData[i];
        let rangeDes = "0%";
        if (data.buyVipRate >= 0) {
          rangeDes = (data.buyVipRate * 100).toFixed(2) + "%";
        }
        data.rangeDes = rangeDes;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/marketing-manager/buy-card-success/index.vue